import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";


export default class EntityFinderContactTab extends EntityFinderTabBase {

  static get $name() {
    return "EntityFinderContactTab";
  }

  static get type() {
    return "entityfindercontacttab";
  }

  static get configurable() {
    return super.getTabWidget("Contacts", {type: WIDGET_KEYS.columnEntityMainName, text: "Contacts", field: "name"})
  }

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.contactFinder, record, { contactRecord: record });
  }

  get storeKey() {
    return STORE_KEYS.contactStore;
  }

  loadRecord(record, context, otherParams) {
    if (!otherParams.isOnlyFinder) {
      this.disabled = true;
    } else {
      this.disabled = false;
      super.loadRecord(record, context, otherParams);
    }
  }
}

EntityFinderContactTab.initClass();